import { makeStyles } from '@material-ui/core/styles';
import { estilosTextosPrincipales, colores, backgroundRectangle, buttonPrimaryBig } from '../../../AppStyle';
import { createMuiTheme } from '@material-ui/core';


export const style = makeStyles({
    classGridContenedor: {
        ...backgroundRectangle,
        width: '100%',
        marginBottom: '0'
    },
    classGridSelect: {
        margin: '19px auto auto 32px'
    },
    classH2: {
        ...estilosTextosPrincipales.encabezadoH2,
        color: colores.escalaGrises.cien,
        marginLeft: '95px',
        marginTop: '2%',
    },
    classButton: {
        ...buttonPrimaryBig,
        marginRight:'1% !important',
        width: '225px',
        marginTop: '1% !important'


        
    },
    classBorrame: {
        marginTop: '10px',
    },
    classTable: {
        backgroundColor: '',
        width: '100%',
        height: '300px',
        margin: 'auto 32px 0px 32px'
    },
    classPager: {
        marginRight: '28px'
    },
    //Estilos aplicados a los selectores
    classGrid: {
        textAlign: 'left',
        marginTop: '15px',
        marginBottom: '19px',
        marginRight: '32px',
        width: 'auto',
        display: 'block',
    },
    classInputLabel: {
        ...estilosTextosPrincipales.body2,
        color: colores.escalaGrises.ochenta,
        fontSize: '12px',
        fontWeight: 'bold',
        letterSpacing: '0',
        lineHeight: ' 17px',
        marginBottom: '5px',
        position: 'relative',
        '&.Mui-focused': {
            color: '#555555',
        },
    },
    classSpanRequired: {
        color: colores.principales.required,
        ...estilosTextosPrincipales.body2,
    },
    pageTitle: {
        ...estilosTextosPrincipales.encabezadoH3,
        fontWeight: 'bold !important',
        fontSize: '22px !important',
        lineHeight: '32px !important'
    },
    gridPageTitle: {
        alignItems: 'center',
        display: 'flex'
    },
    gridSearchBar: {
        marginLeft: '30%',
        alignSelf: 'center',
        display: 'grid',
        width: '30%'
    
    },
    ///////////////////////////////BACKDROP
    classBackdrop: {
        zIndex: 1,
        color: '#fff',
    },
    classInputImportarStyle: {
        display: 'none'
    }
    
});

export const objStyle = {
    classGridPager: {
        direction: "row",
        justify: "flex-end",
        alignItems: "center"
    }
}

export const theme = createMuiTheme({
    overrides: {
        MuiMenu: {
            list: {
                margin: '0px'
            }
        },
        MuiMenuItem: {
            root: {
                ...estilosTextosPrincipales.body1
            }
        }
    }
});